import { Routes } from '@angular/router';
import { authGuard, guestGuard, adminGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/auth/login', pathMatch: 'full' },

  // Auth (guest-only — admin login)
  {
    path: 'auth',
    loadComponent: () => import('./layouts/auth-layout/auth-layout').then((m) => m.AuthLayout),
    canActivate: [guestGuard],
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'login',
        loadComponent: () => import('./pages/auth/login/login.page').then((m) => m.LoginPage),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./pages/auth/forgot-password/forgot-password.page').then(
            (m) => m.ForgotPasswordPage,
          ),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./pages/auth/reset-password/reset-password.page').then(
            (m) => m.ResetPasswordPage,
          ),
      },
    ],
  },

  // Admin app shell (admin role required)
  {
    path: 'app',
    loadComponent: () => import('./layouts/app-shell/app-shell').then((m) => m.AppShell),
    canActivate: [authGuard, adminGuard],
    children: [
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
      {
        path: 'overview',
        loadComponent: () =>
          import('./pages/admin/overview/overview.page').then((m) => m.OverviewPage),
      },
      {
        path: 'workspaces',
        loadComponent: () =>
          import('./pages/admin/workspaces/workspaces.page').then((m) => m.WorkspacesPage),
      },
      {
        path: 'users',
        loadComponent: () => import('./pages/admin/users/users.page').then((m) => m.UsersPage),
      },
      {
        path: 'clients',
        loadComponent: () =>
          import('./pages/admin/clients/clients.page').then((m) => m.ClientsPage),
      },
      {
        path: 'subscriptions',
        loadComponent: () =>
          import('./pages/admin/subscriptions/subscriptions.page').then((m) => m.SubscriptionsPage),
      },
      {
        path: 'packages/:id',
        loadComponent: () =>
          import('./pages/admin/packages/package-detail.page').then((m) => m.PackageDetailPage),
      },
      {
        path: 'packages',
        loadComponent: () =>
          import('./pages/admin/packages/packages.page').then((m) => m.PackagesPage),
      },
      {
        path: 'plans/:id',
        loadComponent: () =>
          import('./pages/admin/plans/plan-detail.page').then((m) => m.PlanDetailPage),
      },
      {
        path: 'plans',
        loadComponent: () => import('./pages/admin/plans/plans.page').then((m) => m.PlansPage),
      },
      {
        path: 'payments',
        loadComponent: () =>
          import('./pages/admin/payments/payments.page').then((m) => m.PaymentsPage),
      },
      {
        path: 'audit',
        loadComponent: () => import('./pages/admin/audit/audit.page').then((m) => m.AuditPage),
      },
      {
        path: 'ai-logs',
        loadComponent: () => import('./pages/admin/ai-logs/ai-logs.page').then((m) => m.AiLogsPage),
      },
      {
        path: 'olap-benchmark',
        loadComponent: () =>
          import('./pages/admin/olap-benchmark/olap-benchmark.page').then(
            (m) => m.OlapBenchmarkPage,
          ),
      },
      {
        path: 'data-source-types',
        loadComponent: () =>
          import('./pages/admin/data-source-types/data-source-types.page').then(
            (m) => m.DataSourceTypesPage,
          ),
      },
      {
        path: 'migrations',
        loadComponent: () =>
          import('./pages/admin/migrations/migrations.page').then((m) => m.MigrationsPage),
      },
      {
        path: 'settings/profile',
        loadComponent: () =>
          import('./pages/settings/profile/profile.page').then((m) => m.ProfilePage),
      },
    ],
  },

  { path: '**', redirectTo: '/auth/login' },
];
